import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Necesito saber de tecnología?',
  answer: 'No. Si sabes usar WhatsApp, puedes hacer esto.'
}, {
  question: '¿Y si no puedo conectarme en vivo?',
  answer: 'Grabación el mismo día, de por vida.'
}, {
  question: '¿Qué herramienta usamos?',
  answer: 'Te la muestro en el workshop. Tiene versión gratis.'
}, {
  question: '¿Salgo con la página hecha?',
  answer: 'Sales con tu página publicada. Ese es el trato.'
}, {
  question: '¿Sirve para negocio físico?',
  answer: 'Sí. Restaurantes, salones, coaches, abogados.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 px-4 bg-violet-50" data-id="element-12">
      <div className="max-w-4xl mx-auto" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-14">
          <h2 className="font-playfair text-4xl md:text-6xl font-bold text-gray-900 mb-12 text-center" data-id="element-15">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-4" data-id="element-16">
            {faqs.map((faq, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-17">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-violet-50 transition-colors" data-id="element-18">
                  <span className="font-bold text-lg md:text-xl text-gray-900 pr-4" data-id="element-19">
                    {faq.question}
                  </span>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.3
              }} data-id="element-20">
                    <ChevronDownIcon className="w-6 h-6 text-violet-600 flex-shrink-0" data-id="element-21" />
                  </motion.div>
                </button>

                <AnimatePresence data-id="element-22">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-23">
                      <div className="px-6 pb-6 text-lg text-gray-700" data-id="element-24">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}